import React, { useEffect, useState } from "react";
import TensoNews from "../../assets/images/TensoBlog/TagNews.svg";
import Img1 from "../../assets/images/maqueta/Tensolite1.png";
import CardBlog from "./CardBlog";
import ShareIcon from "@mui/icons-material/Share";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Tik from "../../assets/images/icons/tiktok-blanco.png";
import { useParams } from "react-router-dom";
import useNews from "../../hooks/useNews";
import ShareModal from "./ShareModal";
import CloseIcon from "@mui/icons-material/Close";
import { lightBlue } from "@mui/material/colors";
import SearchIcon from "@mui/icons-material/Search";
import imgBannerMobile from "../../assets/images/TensoBlog/baner-mobile.png";
import imgBannerTablet from "../../assets/images/TensoBlog/baner-tablet.png";
import imgBannerDisensa from "../../assets/images/TensoBlog/banner-disensa-tablet.png";
import { isVideov2 } from "../../helpers/isVideo";

function NewsTensoBlog() {
  const params = useParams();
  const { news, obtenerNoticia, noticia } = useNews();
  const [titlePage, setTitlePage] = useState("");
  const [loading, setLoading] = useState(false);
  const [share, setShare] = useState(false);

  const shareActive = () => {
    setShare(!share);
  };

  useEffect(() => {
    const newTitle = params.id.replaceAll("-", " ");
    obtenerNoticia({ title: newTitle });
  }, [params.id]);

  setTimeout(() => {
    setTitlePage(noticia?.title);
  }, 500);

  useEffect(() => {
    document.title = titlePage ? titlePage : "Tensolite";
  }, [titlePage]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 2000);
  }, []);
  const baseUrl = "https://tensolite.com";
  const urlBlog = noticia?.title?.replaceAll(" ", "-");
  const urlSinPuntos = urlBlog?.split(".")[0];
  const urlArticlePost = `${baseUrl}/nueva-noticias/${urlSinPuntos}`;
  const imageUrl = noticia?.imageCover ? noticia?.imageCover[0]?.url : "";

  useEffect(() => {
    const imageBaseUrl = "https://tensocombetest.sitenso.link";
    const imageUrlSinLocalhost = imageUrl?.startsWith("http://localhost:9001")
      ? imageUrl?.replace("http://localhost:9001", imageBaseUrl)
      : imageUrl;

    const title = noticia?.title;
    const description = noticia?.titleBody;

    function crearOActualizarMetaTag(propiedad, contenido, name) {
      let metaTagExistente;

      if ((name && !propiedad) || propiedad === "_") {
        metaTagExistente = document.querySelector(`meta[name="${name}"]`);
      } else {
        metaTagExistente = document.querySelector(
          `meta[property="${propiedad}"]`
        );
      }
      if (metaTagExistente) {
        metaTagExistente.setAttribute("content", contenido);
      } else {
        const metaTag = document.createElement("meta");
        if (propiedad !== "_") {
          metaTag.setAttribute("property", propiedad);
        } else {
          metaTag.setAttribute("name", name);
        }
        metaTag.setAttribute("content", contenido);
        document.head.appendChild(metaTag);
      }
    }

    crearOActualizarMetaTag("_", title, "title");
    crearOActualizarMetaTag("_", description, "description");
    crearOActualizarMetaTag("twitter:card", "summary_large_image");
    crearOActualizarMetaTag("twitter:site", "@tensolite");
    crearOActualizarMetaTag("twitter:creator", "@tensolite");
    crearOActualizarMetaTag("twitter:title", title);
    crearOActualizarMetaTag("twitter:description", description);
    crearOActualizarMetaTag("twitter:image", imageUrlSinLocalhost);
    crearOActualizarMetaTag("twitter:url", urlArticlePost);
    crearOActualizarMetaTag("og:title", title, "title");
    crearOActualizarMetaTag("og:description", description, "description");
    crearOActualizarMetaTag("og:image", imageUrlSinLocalhost, "image");
    crearOActualizarMetaTag("og:url", urlArticlePost);
    crearOActualizarMetaTag("og:image:width", "1280");
    crearOActualizarMetaTag("og:image:height", "640");
    document.title = title;
  }, [
    baseUrl,
    noticia?.title,
    noticia?.titleBody,
    noticia?.imageCover,
    urlArticlePost,
  ]);

  const [width, setWidth] = useState(1024);
  useEffect(() => {
    const updateWidth = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateWidth);

    if (window.innerWidth <= 860) setWidth(window.innerWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  const SkeletonNews = () => {
    return (
      <div className="main-news">
        <div className="container-News-display">
          <div className="container-News">
            <article className="skeleton container-News-TensoBlog">
              <div className="container-img-new">
                <div className="container-img"></div>
                <div className="title-img-news">
                  <div className="text">
                    <h3>{noticia?.category}</h3>
                    <h1>{noticia?.title}</h1>
                  </div>
                  <button type="button">
                    <ShareIcon sx={{ color: "white" }} />
                  </button>
                </div>
              </div>
              <div className="container-sub-redes">
                <div className="redes">
                  <FacebookIcon sx={{ color: "white" }} />
                  <InstagramIcon sx={{ color: "white" }} />
                  <YouTubeIcon sx={{ color: "white" }} />
                  <img className="tiktok" src={Tik} alt="" />
                </div>
                <h2 dangerouslySetInnerHTML={{ __html: noticia?.top }}></h2>
              </div>
              <div className="line-new-blog">............</div>
              <div className="body-text-new-blog">
                <p dangerouslySetInnerHTML={{ __html: noticia?.body }}></p>
                {noticia?.multimedia === false ? null : (
                  <iframe
                    title={noticia?.title}
                    srcDoc={`
                              <style>
                                  body, .full {
                                      width: 100%;
                                      height: 100%;
                                      margin: 0;
                                      position: absolute;
                                      display: flex;
                                      justify-content: center;
                                      object-fit: cover;
                                  }
                              </style>
                              <a
                                  href='${noticia?.video}?autoplay=1'
                                  class='full'
                              >
                                  <img
                                      src='http://img.youtube.com/vi/${noticia?.video?.replace(
                                        "https://www.youtube.com/embed/",
                                        ""
                                      )}/0.jpg'
                                      class='full'
                                  />
                                  <svg
                                      version='1.1'
                                      viewBox='0 0 68 48'
                                      width='68px'
                                      style='position: relative;'
                                  >
                                      <path d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
                                      <path d='M 45,24 27,14 27,34' fill='#fff'></path>
                                  </svg>
                              </a>
                          `}
                    style={{
                      maxWidth: "640px",
                      width: "100%",
                      aspectRatio: "16/9",
                    }}
                    allow="autoplay *; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    frameBorder="0"
                  ></iframe>
                )}
              </div>
            </article>
            <div className="container-main-advertising">
              <div className="skeleton container-main-cotizador">
                <img
                  className="container-main-cotizador--img-banner"
                  src={width < 569 ? imgBannerMobile : imgBannerTablet}
                  alt=""
                />
                {width >= 569 ? (
                  <img
                    className="container-main-cotizador--img-banner"
                    src={imgBannerDisensa}
                    alt=""
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className="container-tag-article">
            <ul>
              {noticia?.tags?.length > 0 &&
                noticia?.tags?.map((tag) => <li key={tag}>{tag}</li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="main-news">
      <img className="tag-tensoBlog" src={TensoNews} alt="Tenso News" />
      {loading ? (
        <div className="container-News-display">
          <div className="container-News">
            <article className="container-News-TensoBlog">
              <div className="container-img-new">
                <div className="container-img">
                  {noticia?.multimedia ? (
                    <iframe
                      title={noticia?.title}
                      srcDoc={`
                            <style>
                                body, .full {
                                    width: 100%;
                                    height: 100%;
                                    margin: 0;
                                    position: absolute;
                                    display: flex;
                                    justify-content: center;
                                    object-fit: cover;
                                }
                            </style>
                            <a
                                href='${noticia?.video}?autoplay=1'
                                class='full'
                            >
                                <img
                                    src='http://img.youtube.com/vi/${noticia?.video?.replace(
                                      "https://www.youtube.com/embed/",
                                      ""
                                    )}/0.jpg'
                                    class='full'
                                />
                                <svg
                                    version='1.1'
                                    viewBox='0 0 68 48'
                                    width='68px'
                                    style='position: relative;'
                                >
                                    <path d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
                                    <path d='M 45,24 27,14 27,34' fill='#fff'></path>
                                </svg>
                            </a>
                        `}
                      style={{
                        maxWidth: "640px",
                        width: "100%",
                        aspectRatio: "16/9",
                      }}
                      allow="autoplay *; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      frameBorder="0"
                    ></iframe>
                  ) : isVideov2(noticia?.imageCover[0]?.url) ? (
                    <video
                      src={
                        noticia?.imageCover ? noticia?.imageCover[0]?.url : ""
                      }
                      controls
                      style={{
                        width: "100%",
                        height: "100%",
                        margin: 0,
                        display: "flex",
                        justifyContent: "center",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        noticia?.imageCover?.length === 0
                          ? noticia?.video
                          : noticia?.imageCover[0]?.url
                      }
                      alt={
                        noticia?.imageCover
                          ? noticia?.imageCover[0]?.alt
                          : noticia?.title
                      }
                      title={noticia?.title}
                    />
                  )}
                </div>
                <div className="title-img-news">
                  <div className="text">
                    <h3>{noticia?.category}</h3>
                    <h1>{noticia?.title}</h1>
                  </div>
                  <button onClick={shareActive} type="button">
                    <ShareIcon sx={{ color: "white" }} />
                  </button>
                </div>
              </div>
              <div className="container-sub-redes">
                <div className="redes">
                  <FacebookIcon sx={{ color: "white" }} />
                  <InstagramIcon sx={{ color: "white" }} />
                  <YouTubeIcon sx={{ color: "white" }} />
                  <img className="tiktok" src={Tik} alt="" />
                </div>
                <h2 dangerouslySetInnerHTML={{ __html: noticia?.top }}></h2>
              </div>
              <div className="line-new-blog">............</div>
              <div className="body-text-new-blog">
                <p dangerouslySetInnerHTML={{ __html: noticia?.body }}></p>
              </div>
            </article>
            <div className="container-main-advertising">
              <div className="container-main-cotizador">
                <img
                  className="container-main-cotizador--img-banner"
                  src={width < 569 ? imgBannerMobile : imgBannerTablet}
                  alt=""
                />
                {width >= 569 ? (
                  <img
                    className="container-main-cotizador--img-banner"
                    src={imgBannerDisensa}
                    alt=""
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className="container-tag-article">
            <ul>
              {noticia?.tags?.length > 0 &&
                noticia?.tags?.map((tag) => <li key={tag}>{tag}</li>)}
            </ul>
          </div>
          {share ? (
            <div className="shere-generated">
              <button
                onClick={shareActive}
                className="close-btn-share"
                type="button"
              >
                <CloseIcon sx={{ color: "black" }} />
              </button>
              <ShareModal noticia={noticia} />
            </div>
          ) : null}
        </div>
      ) : (
        <SkeletonNews />
      )}
      <div className="line-new-blog">............</div>
      <div className="container-main-news">
        {news?.map(
          (noticia, index) =>
            noticia?.deleted === false &&
            noticia?.visible === true &&
            noticia?.publish === true && (
              <CardBlog
                key={index}
                noticia={noticia}
                tensoblog={true}
                loading={loading}
                tensoblogClass={true}
              />
            )
        )}
      </div>
    </div>
  );
}

export default NewsTensoBlog;
